export const GOLF_CART_STATUSES = {
  NONE: 'none',
  REQUESTED: 'requested',
  PAID: 'paid',
  CONFIRMED: 'confirmed',
  DENIED: 'denied',
}
